import m from "./../../../dist/es2015/themes/Ktit.js";
export const am5themes_Ktit = m;